import Cookies from 'js-cookie'

export const validateSso = (
  lanId: string | undefined,
  shouldValidate: boolean,
  onMismatch: () => void,
): boolean => {
  if (!shouldValidate) return true

  const ssoCookie = Cookies.get('SSOSESSIONINFO')
  if (!ssoCookie) return true

  try {
    const sessionDetails = JSON.parse(window.atob(ssoCookie))
    if (!sessionDetails.user || !sessionDetails.login_status) {
      onMismatch()
      return false
    }

    const isDifferentUser =
      lanId &&
      String(lanId).toLowerCase() !== String(sessionDetails.user).toLowerCase()
    if (isDifferentUser) {
      onMismatch()
      return false
    }
  } catch {
    onMismatch()
    return false
  }

  return true
}
